<template>
  <t-form :data="formComponent" :rules="rulesComponent" ref="formComponent" @submit.native.prevent label-width="100px">
    <t-form-item label="组件名称" name="name">
      <t-input v-model="formComponent.name"></t-input>
    </t-form-item>
    <t-form-item label="选择看板" name="boardId">
      <t-select v-model="formComponent.boardId" filterable :disabled="!!propBoardId" placeholder="请选择">
        <t-option v-for="item in boardListCal" :key="item.key" :label="item.label" :value="item.value"></t-option>
      </t-select>
      <div style="display: inline-block; color: orange" v-show="!loadingBoardList && !boardListCal.length">
        <icon name="error-circle" />
        你还没有看板，先去自定义看板中新建一个吧
      </div>
    </t-form-item>

    <t-form-item label="图表样式" name="chartType">
      <t-radio-group v-model="formComponent.chartType" size="medium" @change="handleChartTypeChange">
        <t-radio-button
          v-for="item in chartTypeListCal"
          :value="item.value"
          :disabled="item.disabled"
          :key="item.value"
        >
          {{ item.label }}
        </t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="组件规格" name="size">
      <t-radio-group v-model="formComponent.size" size="medium">
        <t-radio-button v-for="item in sizeListCal" :value="item.value" :disabled="item.disabled" :key="item.value">
          {{ item.label }}
        </t-radio-button>
      </t-radio-group>
    </t-form-item>

    <t-form-item label="组件备注" name="remark" key="remark">
      <t-textarea v-model="formComponent.remark"></t-textarea>
    </t-form-item>
  </t-form>
</template>

<script>
import { pick } from 'lodash';
import { CHART_TYPE } from '@/utils/config';
import { getGroupList } from '@/api/analysis/custom-overview';

export default {
  name: 'SaveComponentForm',
  props: {
    saveType: {
      type: String,
      required: true,
    },
    boardInfo: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingBoardList: true,
      boardList: [],
      chartTypeList: [
        { label: '折线图', value: CHART_TYPE.CHART_LINE },
        { label: '表格', value: CHART_TYPE.TABLE },
      ],
      disabledChartTypeList: [],
      sizeList: [
        // { label: '小卡片(1*1)', value: 'small' },
        { label: '中卡片(2*2)', value: 'middle' },
        { label: '中卡片(2*3)', value: 'middle23' },
        { label: '大卡片(4*3)', value: 'large' },
      ],
      disabledSizeList: [],

      propBoardId: '',
      formComponent: {
        id: '',
        name: '',
        boardId: '',
        chartType: '',
        size: '',
        remark: '',
        ext: '',
        lineCount: 10, // 默认前十条
      },
      rulesComponent: {
        name: [
          { required: true, message: '请输入组件名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' },
        ],
        boardId: [{ required: true, message: '请选择看板', trigger: 'blur' }],
        chartType: [{ required: true, message: '请选择图表样式', trigger: 'blur' }],
        size: [{ required: true, message: '请选择组件规格', trigger: 'blur' }],
      },
    };
  },
  computed: {
    chartTypeListCal() {
      return this.chartTypeList.map(item => {
        const nItem = {
          ...item,
          disabled: false,
        };
        if (this.disabledChartTypeList.includes(nItem.value)) {
          nItem.disabled = true;
        }
        return nItem;
      });
    },
    sizeListCal() {
      const { chartType } = this.formComponent;
      return this.sizeList.map(item => {
        const nItem = {
          ...item,
          disabled: false,
        };
        if (chartType === CHART_TYPE.TABLE) {
          // 表格时，只能选择大卡 4*3
          if (nItem.value !== 'large') {
            nItem.disabled = true;
          }
        }
        return nItem;
      });
    },
    boardListCal() {
      if (this.propBoardId) {
        return [...this.boardList, { label: this.boardInfo.name, value: this.propBoardId, key: 'prop-board' }];
      }
      return this.boardList;
    },
  },
  created() {
    this.propBoardId = this.form.boardId; // 设置属性带过来的看板id
    const tmpForm = pick(this.form, ['id', 'name', 'boardId', 'chartType', 'size', 'remark', 'ext']);

    Object.assign(this.formComponent, tmpForm);

    this.handleGetBoardList();
  },
  methods: {
    async handleGetBoardList() {
      try {
        this.loadingBoardList = true;
        const res = await getGroupList({ params: { groupType: 0, isShowBoard: true } });
        const arr = [];
        res.forEach(groupItem => {
          if (groupItem.boardList) {
            groupItem.boardList.forEach(boardItem => {
              arr.push({
                label: boardItem.name,
                value: boardItem.id,
                key: `${groupItem.id}-${boardItem.id}`,
              });
            });
          }
        });
        this.boardList = arr;
      } finally {
        this.loadingBoardList = false;
      }
    },

    handleChartTypeChange() {
      const { chartType, size } = this.formComponent;
      const validSizeList = this.sizeListCal.filter(item => !item.disabled);
      if (validSizeList.findIndex(item => item.value === size) === -1) {
        this.formComponent.size = validSizeList[0].value;
      }
    },

    validate() {
      return this.$refs.formComponent.validate();
    },

    resetFields() {
      this.$refs.formComponent.reset();
    },

    getForm() {
      return JSON.parse(JSON.stringify(this.formComponent));
    },
  },
};
</script>

<style scoped></style>
